import React,{ Fragment, useEffect } from "react";

import "assets/scss/custom/components/_toast.scss";
import { Toast, ToastBody } from "reactstrap";

const ToastDialog = ({ message, showToast ,role, onCloseFn}) => {


    useEffect(()=>{
        setTimeout(() => {
            onCloseFn()    
        }, 2000);
        
    },[message])

    const filterClass = ()=>{
        let toastClass = ''
        switch (role) {
            case 'error':
                toastClass= 'toast-error'
                break;
            case 'info':
                toastClass= 'toast-info'
                break;
            case 'warning':
                toastClass= 'toast-warn'
            break;
            case 'success':
                toastClass= 'toast-success1'
            break;
            default:
                break;
        }
        return toastClass;
    }

    return (
        <Fragment>
            <div className="position-fixed top-0 end-0 p-3 text-white" style={{ zIndex: "1005" }} >
                <Toast  className={`rounded ${filterClass()}`} isOpen={showToast}>
                <ToastBody>
                        {message}
                    </ToastBody>
                </Toast>
            </div>
        </Fragment>
    )
  }

  export default ToastDialog